// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__0eP9D","layout-body":"style_layout-body__wT9s0"};